import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pageitemdefault"
    }}>{`PageItemDefault`}</h1>
    <p>{`Default page item formatting properties.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`TransparencySetting `}<strong parentName="p">{`transparencySettings`}</strong>{` `}</p>
      <p parentName="blockquote">{`Transparency settings.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`StrokeTransparencySetting `}<strong parentName="p">{`strokeTransparencySettings`}</strong>{` `}</p>
      <p parentName="blockquote">{`Transparency settings for the stroke.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`FillTransparencySetting `}<strong parentName="p">{`fillTransparencySettings`}</strong>{` `}</p>
      <p parentName="blockquote">{`Transparency settings for the fill applied to the PageItemDefault.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`ContentTransparencySetting `}<strong parentName="p">{`contentTransparencySettings`}</strong>{` `}</p>
      <p parentName="blockquote">{`Transparency settings for the content of the PageItemDefault.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the PageItemDefault (a Application or Document).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Preferences `}<strong parentName="p">{`preferences`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of preferences objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CornerOptions `}<strong parentName="p">{`topLeftCornerOption`}</strong>{` `}</p>
      <p parentName="blockquote">{`The shape to be applied to the top left corner of rectangular shapes and all corners of non-rectangular shapes.Note: corner option differs from end join in which you can set a radius for a corner option, whereas the rounded or beveled effect of an end join depends on the stroke weight.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CornerOptions `}<strong parentName="p">{`topRightCornerOption`}</strong>{` `}</p>
      <p parentName="blockquote">{`The shape to apply to the top right corner of rectangular shapes`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CornerOptions `}<strong parentName="p">{`bottomLeftCornerOption`}</strong>{` `}</p>
      <p parentName="blockquote">{`The shape to apply to the bottom left corner of rectangular shapes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CornerOptions `}<strong parentName="p">{`bottomRightCornerOption`}</strong>{` `}</p>
      <p parentName="blockquote">{`The shape to apply to the bottom right corner of rectangular shapes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`topLeftCornerRadius`}</strong>{` `}</p>
      <p parentName="blockquote">{`The radius in measurement units of the corner effect applied to the top left corner of rectangular shapes and all corners of non-rectangular shapes`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`topRightCornerRadius`}</strong>{` `}</p>
      <p parentName="blockquote">{`The radius in measurement units of the corner effect applied to the top right corner of rectangular shapes`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`bottomLeftCornerRadius`}</strong>{` `}</p>
      <p parentName="blockquote">{`The radius in measurement units of the corner effect applied to the bottom left corner of rectangular shapes`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`bottomRightCornerRadius`}</strong>{` `}</p>
      <p parentName="blockquote">{`The radius in measurement units of the corner effect applied to the bottom right corner of rectangular shapes`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ObjectStyle `}<strong parentName="p">{`appliedGraphicObjectStyle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The default graphic object style applied to the PageItemDefault. Can also accept: String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ObjectStyle `}<strong parentName="p">{`appliedTextObjectStyle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The default text object style applied to the PageItemDefault. Can also accept: String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ObjectStyle `}<strong parentName="p">{`appliedGridObjectStyle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The default frame grid object style applied to the PageItemDefault. Can also accept: String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Swatch `}<strong parentName="p">{`fillColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The swatch (color, gradient, tint, or mixed ink) applied to the fill of the PageItemDefault. . Can also accept: String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`fillTint`}</strong>{` `}</p>
      <p parentName="blockquote">{`The percent of tint to use in the PageItemDefault's fill color. (To specify a tint percent, use a number in the range of 0 to 100; to use the inherited or overridden value, use -1.)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`strokeWeight`}</strong>{` `}</p>
      <p parentName="blockquote">{`The weight (in points) to apply to the PageItemDefault's stroke.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`miterLimit`}</strong>{` `}</p>
      <p parentName="blockquote">{`The limit of the ratio of stroke width to miter length before a miter (pointed) join becomes a bevel (squared-off) join.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EndCap `}<strong parentName="p">{`endCap`}</strong>{` `}</p>
      <p parentName="blockquote">{`The end shape of an open path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EndJoin `}<strong parentName="p">{`endJoin`}</strong>{` `}</p>
      <p parentName="blockquote">{`The corner join applied to the PageItemDefault.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`StrokeStyle `}<strong parentName="p">{`strokeType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of the stroke style to apply. Can also accept: String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ArrowHead `}<strong parentName="p">{`leftLineEnd`}</strong>{` `}</p>
      <p parentName="blockquote">{`The arrowhead applied to the start of the path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ArrowHead `}<strong parentName="p">{`rightLineEnd`}</strong>{` `}</p>
      <p parentName="blockquote">{`The arrowhead applied to the end of the path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Swatch `}<strong parentName="p">{`strokeColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The swatch (color, gradient, tint, or mixed ink) applied to the stroke of the PageItemDefault. Can also accept: String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`strokeTint`}</strong>{` `}</p>
      <p parentName="blockquote">{`The percent of tint to use in object's stroke color. (To specify a tint percent, use a number in the range of 0 to 100; to use the inherited or overridden value, use -1.)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`gradientFillAngle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The angle of a linear gradient applied to the fill of the PageItemDefault. (Range: -180 to 180)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`gradientStrokeAngle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The angle of a linear gradient applied to the stroke of the PageItemDefault. (Range: -180 to 180)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`overprintStroke`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the PageItemDefault's stroke color overprints any underlying objects. If false, the stroke color knocks out the  underlying colors.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`overprintFill`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the PageItemDefault's fill color overprints any underlying objects. If false, the fill color knocks out the underlying colors.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Swatch `}<strong parentName="p">{`gapColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The swatch (color, gradient, tint, or mixed ink) applied to the gap of a dashed, dotted, or striped stroke. For information, see stroke type.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`gapTint`}</strong>{` `}</p>
      <p parentName="blockquote">{`The tint as a percentage of the gap color. (To specify a tint percent, use a number in the range of 0 to 100; to use the inherited or overridden value, use -1.)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`overprintGap`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the gap color overprints any underlying colors. If false, the gap color knocks out the underlying colors.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`StrokeAlignment `}<strong parentName="p">{`strokeAlignment`}</strong>{` `}</p>
      <p parentName="blockquote">{`The stroke alignment applied to the PageItemDefault.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`nonprinting`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the PageItemDefault does not print.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ArrowHeadAlignmentEnum `}<strong parentName="p">{`arrowHeadAlignment`}</strong>{` `}</p>
      <p parentName="blockquote">{`The arrowhead alignment applied to the PageItemDefault.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`leftArrowHeadScale`}</strong>{` `}</p>
      <p parentName="blockquote">{`The scaling applied to the arrowhead at the start of the path. (Range: 1 to 1000)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`rightArrowHeadScale`}</strong>{` `}</p>
      <p parentName="blockquote">{`The scaling applied to the arrowhead at the end of the path. (Range: 1 to 1000)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`applyObjectStyle`}</strong>{`( ObjectStyle `}<strong parentName="p">{`using`}</strong>{`, Boolean `}<strong parentName="p">{`clearingOverrides`}</strong>{`, Boolean `}<strong parentName="p">{`clearingOverridesThroughRootObjectStyle`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Applies the specified object style.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`ObjectStyle`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`using`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The object style to apply.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`clearingOverrides`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`If true, clears the PageItemDefault's existing attributes before applying the style. (Optional)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`clearingOverridesThroughRootObjectStyle`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`If true, clears attributes and formatting applied to the PageItemDefault that are not defined in the object style. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`clearObjectStyleOverrides`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Clear overrides for object style`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the PageItemDefault.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PageItemDefault `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-2"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      